import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import UI from '../ui';
import Navigation from '../utils/Navigation';
const { Typography, WrappedPopover, Badge, WrappedButton, WrappedButtonType } = UI;

const PrintLimitDetails = ({ monthlyPrintLimit, balancePrintCount, nextBillingDate }) => {
    const usedPrints = monthlyPrintLimit - balancePrintCount;
	return (
        <div className="common-header print-limit-details">
            <Badge steps={usedPrints} totalSteps={monthlyPrintLimit} />
            <Typography.P className="bold">Prints used</Typography.P>
            <WrappedPopover>
                Prints reset on {moment(nextBillingDate).format('MM/DD/YYYY')} and do not roll over to the next cycle.    
            </WrappedPopover>
            <WrappedButton 
                label="Upgrade"
                buttonType={WrappedButtonType.Upgrade}
                onClick={() => {
                    Navigation.navigateTo('storeChangePlan');
                }}
                icon="pi upgrade"
            />
        </div>
	);
};

PrintLimitDetails.propTypes = {
	monthlyPrintLimit: PropTypes.number,
	balancePrintCount: PropTypes.number, 
	nextBillingDate: PropTypes.string
};

export default PrintLimitDetails;
